import { NodeSource, TreeAdapter, TreeOptions, TreeSource } from "@omegagrid/tree";
import { msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';
import { Server } from '@reporting/rp-types/core';

export class ServerTreeAdapter extends TreeAdapter {

	private items: NodeSource[];

	constructor(
		private options?: Partial<TreeOptions>,
		private showAllItem: boolean = false,
	) { super() }

	async getTree(): Promise<TreeSource> {
		if (this.items) return this.items;
		const servers = await rp.ms('server').get<Server[]>('servers');
		// one item per server, not per host: two servers can share a host (different super database),
		// and hiding one of them silently moves whatever pointed at it to the other one
		const ambiguous = new Set(servers.filter(s => servers.some(o => o.id_server !== s.id_server && o.host === s.host)).map(s => s.host));
		this.items = servers.map(s => ({
			k: `${s.id_server}`,
			v: ambiguous.has(s.host) ? `${s.host} (#${s.id_server})` : s.host,
		}));
		if (this.showAllItem) {
			this.items.unshift({ k: null, v: `<${msg('all')}>` });
		}
		return this.items;
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || {};
	}
}
